import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import {ReportService} from '../service/report.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';


export interface Fruit {
  name: string;
}

@Component({
  selector: 'app-table-extraction-filter',
  templateUrl: './table-extraction-filter.component.html',
  styleUrls: ['./table-extraction-filter.component.scss']
})
export class TableExtractionFilterComponent implements OnInit {
  
  public crossTabForm = new FormGroup({
    cuts: this.formBuilder.array([this.createCut(this.reportService.fileUUID)]),
    dataValue : new FormControl('absolute', [Validators.required]),
    viewFormate : new FormControl('tabular', [Validators.required]),
    trendAnalysis : new FormControl(false, [Validators.required]),
  });
  
  public filter_name:string = '';
  public selectedChildren:any = [];
  public t11 :number = 1;
  public maxTopcutLimit :number = 100;
  public maxTopcutLimitPerFile :number = 100;
  public allowed_topcuts:number[] = []
  public nodeItems:any[] =[]

  constructor(public reportService:ReportService,
    public notifier: NotifierService,
    private sidePanelService:SidePanelService,
    private formBuilder: FormBuilder) { 
    this.reportService.getSavedCrossTabs();
  }

  ngOnInit() {
    if(this.reportService.formData){
      // console.log(this.reportService.formData);
      // this.crossTabForm = this.reportService.formData;
      this.crossTabForm = this.reportService.formData;
      // console.log('this.reportService.formData : ', this.reportService.formData.value);
      if (this.crossTabForm.value.cuts.length > 1) {
        this.crossTabForm.patchValue({"trendAnalysis":true})
      }
      
    }

    // this.nodeItems = [{
    //   id: '0',
    //   name: 'Heros',
    //   children: [
    //     {
    //       id: '1',
    //       name: 'Batman',
    //       item: {
    //         phrase: 'I am the batman'
    //       }
    //     },
    //     {
    //       id: '2',
    //       name: 'Superman',
    //       item: {
    //         phrase: 'Man of steel'
    //       }
    //     }
    //   ]
    // },
    // {
    //   id: '3',
    //   name: 'Villains',
    //   children: [
    //     {
    //       id: '4',
    //       name: 'Joker',
    //       item: {
    //         phrase: 'Why so serius'
    //       }
    //     },
    //     {
    //       id: '5',
    //       name: 'Lex luthor',
    //       item: {
    //         phrase: 'I am the villain of this story'
    //       }
    //     }
    //   ]
    // }];

  }
  getMaxTopcutLimitPerFile(totalFiles){
    this.maxTopcutLimitPerFile = Math.floor(this.maxTopcutLimit/totalFiles);
    let items = this.crossTabForm.get('cuts')['controls'];
    items.forEach((cut) => {
      let currentTopcut = cut.get('topcut') as FormArray;
      let selectedTopcut = currentTopcut.value[0];
      if (selectedTopcut.options && selectedTopcut.options.length) {
        selectedTopcut.options = selectedTopcut.options.slice(0,this.maxTopcutLimitPerFile);
        currentTopcut.patchValue([selectedTopcut])
      }
    });
  }
  resetForm(){
    this.crossTabForm = null;
    this.crossTabForm = new FormGroup({
      cuts: this.formBuilder.array([this.createCut(this.reportService.fileUUID)]),
      dataValue : new FormControl('absolute', [Validators.required]),
      viewFormate : new FormControl('tabular', [Validators.required]),
      trendAnalysis : new FormControl(false, [Validators.required]),
    })
    this.changeInCuts();
  }

  createCut(fileUUID): FormGroup {
    let seq = 1;
    if (this.crossTabForm && this.crossTabForm.value.cuts.length) {
      seq = this.crossTabForm.value.cuts.length + 1;
    }
    
    return this.formBuilder.group({
      topcut : this.formBuilder.array([this.createTopcut()]),
      sidecut : this.formBuilder.array([this.createSideut()]),
      fileUUID : new FormControl(fileUUID),
      // dataTreeJSON: this.formBuilder.array([]),
      // treeItemList : this.formBuilder.array([]),
      projectName : new FormControl('select', [Validators.required]),
      seq : new FormControl(seq, [Validators.required]),
      alias : new FormControl(''),
      sideOption: new FormControl({'select':'select'}),
      topOption: new FormControl({'select':'select'})
    });
  }

  findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index);

  addCut(): void {
    let items = this.crossTabForm.get('cuts') as FormArray;
    if((items.length) <= this.reportService.projectList.length){
      items.push(this.createCut(''));
    }else{
      this.notifier.notify('error','Maximum Project Found');
    }
    this.changeInCuts();
  }
  removeCut(index): void {
    let items = this.crossTabForm.get('cuts') as FormArray;
    items.removeAt(index);
    items.value.forEach((element,index) => {
      element.seq = index + 1;
    });
    setTimeout(() =>{
      items.patchValue(items.value)
    },200)
    let projectCount = items.length;
    this.getMaxTopcutLimitPerFile(projectCount)
    this.changeInCuts();
  }
  createTopcut(): FormGroup {
    return this.formBuilder.group({
      name : new FormControl('', [Validators.required]),
      options : new FormControl([], [Validators.required])
    });
  }
  addTopcut(topcut:FormArray): void {
    let items = topcut.get('topcut') as FormArray;
    items.push(this.createTopcut());
    this.changeInCuts();
  }
  removeTopcut(topcut:FormArray, topIndex): void {
    this.changeInCuts();
    let items = topcut.get('topcut') as FormArray;
    if(items.value.length == 1){
      items.reset();
    }else{
      items.removeAt(topIndex);
    }
  }
  createSideut(): FormGroup {
    return this.formBuilder.group({
      name : new FormControl('', [Validators.required]),
      options : new FormControl([], [Validators.required]),
      allowed_topcuts : new FormControl([], [Validators.required]),
    });
  }
  addSideut(sidecut:FormArray): void {
    let items = sidecut.get('sidecut') as FormArray;
    items.push(this.createSideut());
    this.changeInCuts();
  }
  removeSideut(sidecut:FormArray, sideIndex): void {
    this.changeInCuts();
    let items = sidecut.get('sidecut') as FormArray;
    if(items.value.length == 1){
      items.reset();
    }else{
      items.removeAt(sideIndex);
    }
  }

  getCutOptions(id, cut:FormGroup){
    // console.log(id,cut);
    if(id != this.reportService.fileUUID){
      // this.reportService.isLoading = true;
      this.reportService.getCut({uuid:id}).subscribe(data => {
          if (data['status'] == 1) {
            this.reportService.isLoading = false;
            this.reportService.trackerSessionId =  data['result']['session_id'];
            cut.patchValue({
              topOption:data['result']['topcut'],
              sideOption:data['result']['sidecut'],
            });
            // this.createTreeObj(data['result']['topcut'][0],cut)
            this.createTreeObj(data['result']['topcut'],id)
            this.createSidecutTreeObj(data['result']['sidecut'],id);
            this.reportService.crosstabOptions[id] = {};
            this.reportService.crosstabOptions[id] = {"topcut":data['result']['topcut'],"sidecut":data['result']['sidecut']}

          }else if(data['status'] == 4){
            this.notifier.notify('error',data['message']);
            this.sidePanelService.afterLoginNavigate();
            
            // this.reportService.isLoading = false;
          }else{
            this.notifier.notify('error',data['errorMessage']);
            this.reportService.isLoading = false;
          }
        },
        error =>{
          this.notifier.notify('error','Something went wrong');
          this.reportService.isLoading = false;
        }
      );
    }
  }

  createTreeObj(topcutObj, file_uuid){
    this.reportService.isTopcutLoaded = false;
    let dataTreeJSON:any = [];
    let newTopcutObj = [{id:0,topcut:{"Select All": {
      "type": "option",
      "index": 0,
      "sType":"All",
      "name":"Select All"
    }}}]
    topcutObj.forEach(topcut =>{
      newTopcutObj.push(topcut)
    })
    this.reportService.treeItems[file_uuid] = [];
    newTopcutObj.forEach((topcut, index) => {
      this.reportService.recurciveTreeObj(topcut['topcut'], 'root', 'root', "root", topcut['id']+'-', topcut['id'], dataTreeJSON);
    });
    // let newTopcutObj = {"Select All": {
    //   "type": "topcut",
    //   "sType":"All",
    //   "options":topcutObj['topcut']
    // }}
    // let dataTreeJSON:any = [];
    // this.reportService.recurciveTreeObj(newTopcutObj, 'root', topcutObj['id']+'-', topcutObj['id'], dataTreeJSON);
    setTimeout(()=>{
      let treeArray = this.reportService.process(dataTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
        }
      });
      this.reportService.treeItems[file_uuid].push(treeObj);
      // this.reportService.treeItems[file_uuid] = this.reportService.process(dataTreeJSON);
      this.reportService.isTopcutLoaded = true;
    },100)
  }


  createSidecutTreeObj(sidecutV2, file_uuid){
    this.reportService.isSidecutLoaded = false;
    let sidecutTreeJSON:any = [];
    let set = new Set();
    let newSidecutObject = {};
    newSidecutObject['Select All'] = {"name":"Select All","options":[],"allowed_topcuts":[0]};
    Object.keys(sidecutV2).forEach((key,i) =>{
      newSidecutObject[key] = sidecutV2[key];
      // newSidecutObject[key]["pUUID"] = key;
      // newSidecutObject[key]["pUUID"] = key+"-11111-uuid-"+i;

      // newSidecutObject[sidecutV2[key]["name"]] = sidecutV2[key];
      // newSidecutObject[sidecutV2[key]["name"]]["pUUID"] = key;
    })
    Object.keys(newSidecutObject).forEach(key =>{
      let obj = {};
      let sidecutObject = {};
      obj['type'] = 'topcut';
      // obj['pUUID'] = newSidecutObject[key]['pUUID'];
      obj['v'] = newSidecutObject[key]['name'];
      obj['allowed_topcuts'] = newSidecutObject[key]['allowed_topcuts'][0];
      let obj1 = {};
      newSidecutObject[key]['options'].forEach((va,i) =>
      {
        // obj1[i] = va;
        obj1[va["label"]] = va;
      })
      obj['options'] = obj1;
      sidecutObject[key] = obj;
      // console.log("sidecutObject 1111 =>",sidecutObject)
      this.reportService.recurciveSideTreeObj(sidecutObject, 'root', "root", "root", sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'], sidecutTreeJSON);
    });

    // Object.keys(sidecutV2).forEach(key =>{
    //   let sidecutObject = {};
    //   let obj = {};
    //   obj['type'] = 'topcut';
    //   obj['allowed_topcuts'] = sidecutV2[key]['allowed_topcuts'][0];
    //   let obj1 = {};
    //   sidecutV2[key]['options'].forEach((va) =>
    //   {
    //     obj1[va] = va;
    //   })
    //   set.add(sidecutV2[key]['allowed_topcuts'][0]);
    //   obj['options'] = obj1;
    //   sidecutObject[key] = obj;
    //   let arr = Array.from(set);
    //   this.reportService.recurciveTreeObj(sidecutObject, 'root', sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'],sidecutTreeJSON );
    // });

    setTimeout(()=>{
      let treeArray = this.reportService.process(sidecutTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
        }
      });
      this.reportService.sidecutTreeitems[file_uuid] = [];
      this.reportService.sidecutTreeitems[file_uuid].push(treeObj);
      this.reportService.sidecutTreeitemsCopy = JSON.parse(JSON.stringify(this.reportService.sidecutTreeitems))
      // console.log("this.sidecutTreeitems",this.reportService.sidecutTreeitems)
      // this.reportService.sidecutTreeitems[file_uuid] = this.reportService.process(sidecutTreeJSON);
      this.reportService.isSidecutLoaded = true;
    },100)
  }

  // createTreeObj(topcutObj, file_uuid){
  //   let newTopcutObj = {"Select All": {
  //     "type": "topcut",
  //     "sType":"All",
  //     "options":topcutObj['topcut']
  //   }}
  //   let dataTreeJSON:any = [];
  //   this.reportService.recurciveTreeObj(newTopcutObj, 'root', topcutObj['id']+'-', topcutObj['id'], dataTreeJSON);
  //   setTimeout(()=>{
  //     this.reportService.treeItems[file_uuid] = this.reportService.process(dataTreeJSON);
  //     // console.log("tree object is",this.reportService.treeItems)
  //   },2000)
  // }

  // createSidecutTreeObj(sidecutV2, file_uuid){
  //   let sidecutObject = {};
  //   let set = new Set();
  //   Object.keys(sidecutV2).forEach(key =>{
  //     let obj = {};
  //     obj['type'] = 'topcut';
  //     let obj1 = {};
  //     sidecutV2[key]['options'].forEach((va) =>
  //     {
  //       obj1[va] = va;
  //     })
  //     set.add(sidecutV2[key]['allowed_topcuts'][0]);
  //     obj['options'] = obj1;
  //     sidecutObject[key] = obj;
  //   });
  //   let newSidecutObj = {"Select All": {
  //     "type": "topcut",
  //     "sType":"All",
  //     "options":sidecutObject
  //   }}
  //   let arr = Array.from(set);
  //   let sidecutTreeJSON:any = [];
  //   this.reportService.recurciveTreeObj(newSidecutObj, 'root', arr[0]+'-', arr[0],sidecutTreeJSON );
  //   setTimeout(()=>{
  //     this.reportService.sidecutTreeitems[file_uuid] = this.reportService.process(sidecutTreeJSON);
  //     // console.log("sidecuttree object is",this.reportService.sidecutTreeitems);
  //   },2000)
  // }

  // createNestedObject( base, arr ) {
  //   for( var i = 0; i < arr.length; i++ ) {
  //       base = base[ arr[i] ] = base[ arr[i] ] || (arr.length == (i+1) ? {type: 'option'} : {type: 'topcut', options:{}});
  //   }
  // }

  removeEmptyOptions(topcutObj){
    Object.keys(topcutObj).forEach((key)=>{
          if(Object.keys(topcutObj[key]['options']).length == 0){
            delete topcutObj[key]['options'];
          }else{
            this.removeEmptyOptions(topcutObj[key]['options']);
          }
    })
  }

  findID(options){
    let len = 0;
    let key = '';
    options.forEach( (option) => {
      const arr = option['parent'].split('---');
      if(arr.length > len){
        len = arr.length;
        key = arr[1];
      }
    });
    return options[0].id.split('-')[0];
    // return 2;
  }

  onSubmit(){
    this.reportService.onSignificanceReset();
    // console.log(this.crossTabForm.value);
    let request = {};
    let isDublicateSeq = false;
    let sideCutA = [];
    let topCutA = [];
    let isForamtError = false;
    // console.log("cuts are =====> ",this.crossTabForm.value.cuts)

    this.crossTabForm.value.cuts.forEach((cut, index) => {
      request[cut.fileUUID] = {};
      request[cut.fileUUID]['sidecut'] = {};
      // request[cut.fileUUID]['sidecut'] = [];
      request[cut.fileUUID]['topcut'] = [];
      request[cut.fileUUID]['alias'] = cut.alias;
      request[cut.fileUUID]['seq'] = cut.seq;
      if (this.crossTabForm.value.cuts.filter(item =>{return item.seq == cut.seq}).length > 1) {
        let val = this.crossTabForm.value.cuts.filter(item =>{return item.seq == cut.seq});
      }

      let selectedSideCuts = [];
      selectedSideCuts = JSON.parse(JSON.stringify(cut.sidecut));
      // console.log("selectedSideCuts ===> ",selectedSideCuts)
      selectedSideCuts.forEach(side => {
        let sidecutObj = {};
        sidecutObj['id'] = this.findID(side.options);
        sidecutObj['sidecut'] = {};
        side.options.forEach( option => {
          let splitOption = option['parent'].split('---');
          if (!(option['sType'] && option['sType'] == "All")) {
            if (option['name']) {
              splitOption.push(option['name']);
            }
            splitOption.splice(0,1);
            // sidecutObj['sidecut'][splitOption[0]] = sidecutObj['sidecut'][splitOption[0]] || {};
            // if (option["parentUUID"]) {
            //   sidecutObj['sidecut'][option["parentUUID"]] = sidecutObj['sidecut'][option["parentUUID"]] || {};
            //   sidecutObj['sidecut'][option["parentUUID"]]['name'] = option["p"];
            //   sidecutObj['sidecut'][option["parentUUID"]]['allowed_topcuts'] = sidecutObj['sidecut'][option["parentUUID"]]['allowed_topcuts'] || [];
            //   sidecutObj['sidecut'][option["parentUUID"]]['allowed_topcuts'].push(option['allowed_topcuts']);
            //   sidecutObj['sidecut'][option["parentUUID"]]['options'] = sidecutObj['sidecut'][option["parentUUID"]]['options'] || [];
            //   sidecutObj['sidecut'][option["parentUUID"]]['options'].push({v:option['name'],label:option['label']});
            // }else{
            //   sidecutObj['sidecut'][splitOption[0]] = sidecutObj['sidecut'][splitOption[0]] || {};
            //   sidecutObj['sidecut'][splitOption[0]]['name'] = option["p"];
            //   sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'] = sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'] || [];
            //   sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'].push(option['allowed_topcuts']);
            //   sidecutObj['sidecut'][splitOption[0]]['options'] = sidecutObj['sidecut'][splitOption[0]]['options'] || [];
            //   sidecutObj['sidecut'][splitOption[0]]['options'].push({v:option['name'],label:option['label']});
            // }

              sidecutObj['sidecut'][splitOption[0]] = sidecutObj['sidecut'][splitOption[0]] || {};
              sidecutObj['sidecut'][splitOption[0]]['name'] = option["p"];
              sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'] = sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'] || [];
              sidecutObj['sidecut'][splitOption[0]]['allowed_topcuts'].push(option['allowed_topcuts']);
              sidecutObj['sidecut'][splitOption[0]]['options'] = sidecutObj['sidecut'][splitOption[0]]['options'] || [];
              sidecutObj['sidecut'][splitOption[0]]['options'].push({v:option['name'],label:option['label']});
            
            // sidecutObj['sidecut'][splitOption[0]]['options'].push(splitOption[1]);
          }
        });

        // this.removeEmptyOptions(sidecutObj['sidecut']);
        let sidecut = {}
        Object.keys(sidecutObj['sidecut']).forEach(sKey => {
          sidecut[sKey] = {}
          sidecut[sKey]['name'] = sidecutObj['sidecut'][sKey]['name'];
          sidecut[sKey]['allowed_topcuts'] = [];
          sidecut[sKey]['hiddenRows'] = [];
          sidecut[sKey]['options'] = [];

          let hiddenRows = [];
          if (this.reportService.clubbedOptions['rows'][side.name]) {
            this.reportService.clubbedOptions['rows'][side.name].forEach(row => {
              let isRow = side.options.find(item => {return item == row});
              if (!isRow || isRow == "") {
                hiddenRows.push(row)
              }
            });
          }
          sidecut[sKey]['hiddenRows'] = hiddenRows;
          sidecut[sKey]['allowed_topcuts'] = sidecutObj['sidecut'][sKey]['allowed_topcuts'];
          // sidecut[sKey]['options'] = Object.keys(sidecutObj['sidecut'][sKey]['options']);
          sidecut[sKey]['options'] = sidecutObj['sidecut'][sKey]['options'];
        });
        // console.log("sidecut are ===> ",sidecut);
        request[cut.fileUUID]['sidecut']=sidecut;

      });
      // console.log("request[cut.fileUUID]['sidecut'] ===>",request[cut.fileUUID]['sidecut']);

      let selectedTopCuts = [];
      selectedTopCuts = JSON.parse(JSON.stringify(cut.topcut));
      // console.log("selectedTopCuts ===>",selectedTopCuts);
      selectedTopCuts.forEach(top => {
        top.options.forEach(option => {
          option.show = true;
        });
        this.reportService.clubbedOptions['column'].forEach(coption =>{
          // console.log("top.options ===>",top.options)
          // let isCOption = top.options.find(item => { return (item.parent == coption.parent && item.name == coption.name)});
          let isCOption = top.options.find(item => { return (item.parent == coption.parent && item.name == coption.n)});
          if (!isCOption && Object.keys(coption).length > 0) {
            let tempOption = JSON.parse(JSON.stringify(coption));
            tempOption['show'] = false;
            tempOption['name'] = tempOption['n'];
            top.options.push(tempOption);
          }
        })
      });
      let isAllTopcut = false;

      // this.selectedChildren = [];
      // this.getAllChildren(selectedTopCuts)
      // console.log("selected topcut is ====>",selectedTopCuts)
      // console.log("this.selectedChildren is888888888888888 ====>",selectedTopCuts)

      // console.log("allowedTopcutsOptions111 ======> ",selectedTopCuts)
      this.allowed_topcuts = [];
      this.allowed_topcuts = selectedTopCuts[0]['options'].map(item => item.allowed_topcuts);
      this.allowed_topcuts = this.allowed_topcuts.filter((ditem, index) => index === this.allowed_topcuts.indexOf(ditem));
      let allowedTopcutsOptions = []
      this.allowed_topcuts.forEach(at =>{
        let tOptions = selectedTopCuts[0]['options'].filter(item =>{return item.allowed_topcuts == at});
        if (tOptions && tOptions.length) {
          allowedTopcutsOptions.push({name:'',options:tOptions})
        }
      })
      // console.log("allowedTopcutsOptions ===>",allowedTopcutsOptions)
      selectedTopCuts = allowedTopcutsOptions;
      // cut.topcut.forEach(top => {
        selectedTopCuts.forEach(top => {
        let topcutObj = {};
        topcutObj['id'] = this.findID(top.options);
        topcutObj['topcut'] = {};
        top.options.forEach( option => {
          let splitOption = option['parent'].split('---');
          if (option['sType'] && option['sType'] == "All") {
            isAllTopcut = true;
          }else{
            // if (option['name']) {
            //   splitOption.push(option['name']);
            // }
            if (option['uuid']) {
              splitOption.push(option['uuid']);
            }
            splitOption.splice(0,1);
            let map = topcutObj['topcut'];
            for (let i = 0; i < splitOption.length; i++) {
              let item = splitOption[i]
              map[item] = map[item] || {};
              if (Object.keys(map[item]).length > 0 || i < splitOption.length - 1) {
                map[item]['type'] = 'topcut';
              }else{
                map[item]['type'] = 'option';
                map[item]['show'] = option.show;
              }
              map[item]['options'] = map[item]['options'] || {};
              map = map[item]['options'];
            }
          }
        });
        this.removeEmptyOptions(topcutObj['topcut']);
        // if (isAllTopcut) {
        //   delete request[cut.fileUUID].topcut;
        // }else{
        //   request[cut.fileUUID]['topcut'].push(topcutObj);
        // }
        request[cut.fileUUID]['topcut'].push(topcutObj);

      });
      // console.log("request[cut.fileUUID]['topcut'] ===>",request[cut.fileUUID]['topcut'])
    });
    if (isDublicateSeq) {
      this.notifier.notify('error','Please insert valid sequence');
    }else if(this.findDuplicates(sideCutA).length > 0){
      this.notifier.notify('error','Duplicate sidecuts');
    }else if(this.findDuplicates(topCutA).length > 0){
      this.notifier.notify('error','Duplicate topcuts');
    }else if(isForamtError){
      this.notifier.notify('error','Please select sidecut options');
    }else{
      let fileUUId = Object.keys(request);
      request = {"data":request}
      request['dataValue'] = this.crossTabForm.value.dataValue;
      request['viewFormate'] = this.crossTabForm.value.viewFormate;
      request['trendAnalysis'] = this.crossTabForm.value.trendAnalysis;
      this.reportService.formData = this.crossTabForm;
      this.reportService.crossTabReq = request;
      // console.log('crossTabForm : ', this.crossTabForm.value);
      // console.log('get data req : ', request);
      // this.reportService.getDummyExtractedTable();
      this.reportService.getExtractedTable(request);
      this.reportService.otherChecks['dataValue'] = this.crossTabForm.value.dataValue;
      this.reportService.otherChecks['viewFormate'] = this.crossTabForm.value.viewFormate;
      this.reportService.otherChecks['trendAnalysis'] = this.crossTabForm.value.trendAnalysis;
      this.reportService.currentFilter = {"filter_data":this.crossTabForm.value.cuts,"uuid":fileUUId[0]};
      // console.log('this.reportService.currentFilter : ', this.reportService.currentFilter);
    }
    this.reportService.filter_name = this.filter_name;
  }
  
  projectChange(file_uuid, cut:FormGroup){
    cut.patchValue({fileUUID : file_uuid});
    let projectCount = this.crossTabForm.get('cuts')['controls'].length;
    this.getMaxTopcutLimitPerFile(projectCount)
    this.getCutOptions(file_uuid, cut);
  }
  
  switchTrend(){
    if(!this.crossTabForm.value.trendAnalysis){
      let items = this.crossTabForm.get('cuts') as FormArray;
      
      let firstCut = JSON.parse(JSON.stringify(items.at(0).value));
      // console.log(firstCut)
      this.resetForm();
      setTimeout(() =>{
        this.crossTabForm.get('cuts')['controls'][0].patchValue({
          seq:firstCut.seq,
          topcut:firstCut.topcut,
          sidecut:firstCut.sidecut
        })
      },200)
    }
  }

  getAllChildren(obj:any){
    // console.log("obj is =======>  ",obj)
    Object.keys(obj).forEach(element => {
        let item = obj[element];
        item.name = element;
        if(!item.children){
          this.selectedChildren.push(item);
        }
        if(item.children && Object.keys(item.children).length > 0){
          this.getAllChildren(item.options);
        }
    });  
  }
  
  // getAllChildren(obj:any){
  //   console.log("obj is =======>  ",obj)
  //   Object.keys(obj).forEach(element => {
  //       let item = obj[element];
  //       item.name = element;
  //       if(!item.children){
  //         this.selectedChildren.push(item);
  //       }
  //       if(item.children && Object.keys(item.children).length > 0){
  //         this.getAllChildren(item.options);
  //       }
  //   });  
  // }

 cutChange(cuts, options){
    cuts.patchValue({options : options[cuts.value.name]['options']});
    cuts.patchValue({allowed_topcuts : options[cuts.value.name]['allowed_topcuts']});
    this.changeInCuts();
    // console.log("cuts are ",this.crossTabForm.get('cuts')['controls'][1].value.sideOption[cuts.value.name])
  }

  getSavedCutName(cut,length){
    let str = JSON.stringify(cut);
    return str.substring(0,length) + '...';
  }

  changeInCuts(){
    this.reportService.filter_name = '';
    // this.reportService.mainClubReq = {};
  }
    
  pickFilter(workSpace,filter_name){
    // console.log("this.reportService.sidecutTreeitems is ===>",this.reportService.sidecutTreeitems)
      let cut = workSpace.filter;
      console.log("Workspace is ===>",workSpace)
      
      this.resetForm();
      // return

      if (cut.length > 1) {
        this.crossTabForm.patchValue({"trendAnalysis":true});
      }
      for (let i = 0; i < cut.length ; i++) {
        for (let j = 0; j < cut[i].topcut.length - 1; j++) {
          this.addTopcut(this.crossTabForm.get('cuts')['controls'][i]);
        }
        for (let k = 0; k < cut[i].sidecut.length - 1; k++) {
          this.addSideut(this.crossTabForm.get('cuts')['controls'][i]);
        }
        if (i < cut.length - 1) {
          this.addCut();
        }
      }
      
      setTimeout(() =>{
        // console.log("this.crossTabForm",this.crossTabForm.get('cuts'))
        // console.log("cut ",cut)
        this.crossTabForm.patchValue({"cuts":cut});
        
        if (this.crossTabForm.value.trendAnalysis) {
          this.crossTabForm.get('cuts')['controls'].forEach((cut, index) => {
            if (index > 0) {
              this.getCutOptions(cut.value.fileUUID,cut);
            }
          });
        }
  
        this.crossTabForm.patchValue({"dataValue":workSpace.otherChecks['dataValue']});
        this.filter_name = filter_name;
        // console.log("this.reportService.sidecutTreeitemsCopy is ===>",this.reportService.sidecutTreeitemsCopy)
        this.createSidecutTreeObj(this.reportService.sidecutV2,this.reportService.fileUUID);
        // setTimeout(() =>{
        //   this.reportService.sidecutTreeitems = JSON.parse(JSON.stringify(this.reportService.sidecutTreeitemsCopy)) 
        //   console.log("this.reportService.sidecutTreeitems is ===>",this.reportService.sidecutTreeitems)
        // },200)
        setTimeout(() =>{
          this.reportService.mainClubReq = workSpace.club;
          this.reportService.clubbedOptions = workSpace.clubbedOptions ? workSpace.clubbedOptions : {};
        })
      },500)
      
      if(workSpace['significance_test'])
      {
        setTimeout(() =>
        {
          this.reportService.isData = true;
          this.reportService.close();
          this.reportService.resetLastRequest()
          this.reportService.isSignificanceTest = true;
          this.reportService.lastRequest = workSpace['request'];
          this.reportService.sigTestingtype = workSpace['isBeta'] ? 'beta' : 'normal';
          this.reportService.sigComparetype = workSpace['significance_test']['type'];
          this.reportService.sigConfidenceLevel = workSpace['significance_test']['confidence'];
          this.reportService.sigTestingOn = workSpace['significance_test']['sigTestingOn'];
          this.reportService.sigBase = workSpace['significance_test']['sigBase'];
          this.reportService.sigfromAmongarr = [{ withRespect: '', toColumn: [] }];
          this.reportService.mainJsonDataForSig = workSpace['data'];
          this.reportService.sigTreeItemsForWithRespect = workSpace['sigTreeItemsForWithRespect'];
          this.reportService.sigTreeItemsFortoColumn = workSpace['sigTreeItemsFortoColumn'];
          this.reportService.sigSmallBaseToggleButton = workSpace['small_base'];
          this.reportService.formData = this.crossTabForm;
          if(workSpace['significance_test']['significanceValueArray'] && workSpace['significance_test']['significanceValueArray'].length > 0)
          {
            this.reportService.sigfromAmongarr = workSpace['significance_test']['significanceValueArray'];
          }
        },500)
      }

 
    
    // this.reportService.crossTable.patchValue({"uppercut":cut.uppercut});
    // this.reportService.crossTable.patchValue({"undercut":cut.undercut});
  }

  getSelectedParent(topcuts, selectedTopcutOption){
    let parents = [];
    selectedTopcutOption.forEach(option => {
      parents.push(option.p)
    });
    parents = parents.filter(
      (element, i) => i === parents.indexOf(element)
    )
    return parents;
  }

  topcutSelectionchange(selectedTopcut,file_uuid,cut:FormGroup){
    if (selectedTopcut && selectedTopcut.options && selectedTopcut.options.length && selectedTopcut.options.length > this.maxTopcutLimitPerFile) {
      selectedTopcut.options = selectedTopcut.options.slice(0,this.maxTopcutLimitPerFile);
      let currentTopcut = cut.get('topcut') as FormArray;
      currentTopcut.patchValue([selectedTopcut])
      this.notifier.notify('error','Can not exceed more than 100 topcuts')
    }
    this.allowed_topcuts = [];
    this.allowed_topcuts = selectedTopcut['options'].map(item => item.allowed_topcuts);
    this.allowed_topcuts = this.allowed_topcuts.filter((ditem, index) => index === this.allowed_topcuts.indexOf(ditem));
    // console.log("allowed_topcuts are",this.allowed_topcuts);
    let newSidecut = {};
    let sidecut = this.reportService.crosstabOptions[file_uuid]['sidecut']
    // console.log( "this.reportService.crosstabOptions[file_uuid] =====>",this.reportService.crosstabOptions[file_uuid])
    Object.keys(sidecut).forEach(key =>{
        if (this.allowed_topcuts.includes(sidecut[key]['allowed_topcuts'][0])) {
          newSidecut[key] = JSON.parse(JSON.stringify(sidecut[key]))
        }
      })
    // console.log("total sidecuts are ====>",sidecut);
    // console.log("newSidecut are ====>",newSidecut);
    this.createSidecutTreeObj(newSidecut, file_uuid);
  }

}
